import { type AppNode } from '../types';

export const getCanvasNodeVersionMediaUrl = (node: AppNode): string | undefined => {
  if (node.type === 'video') {
    return node.data.media?.original;
  }

  if (node.type === 'image') {
    return node.data.media?.original ?? node.data.media?.image;
  }

  return undefined;
};
